module.exports = __webpack_public_path__ + "static/ASU-1e270d4bc886f1e0eaac1cfaf8a5fb89.jpg";